import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.button.attrs({ type: 'button' })<{
  $selected?: boolean
  $focused?: boolean
}>`
  width: 100%;
  padding-right: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  position: relative;
  height: 40px;

  &:hover {
    background: ${Colors.GS200};
  }

  ${({ $selected, $focused }) =>
    ($selected || $focused) &&
    css`
      background: ${Colors.GS200};
    `}
`

export const CategoryButton = styled.div<{
  $selected?: boolean
}>`
  padding: 8px 12px;
  text-align: left;
  white-space: nowrap;

  strong {
    font-weight: 500;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      font-weight: 600;
    `}
`

export const IconContainer = styled.div<{ $bold?: boolean }>`
  color: ${Colors.GS600};

  ${({ $bold }) =>
    $bold &&
    css`
      color: ${Colors.GS1000};

      svg path {
        stroke-width: 2px;
      }
    `}
`

export const Parent = styled.span`
  color: ${Colors.GS600};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: right;
`
